// noinspection RegExpRedundantEscape

import {NgClass, NgForOf, NgIf} from '@angular/common';
import {AfterViewInit, ChangeDetectorRef, Component, ElementRef, OnInit, ViewChild} from '@angular/core';
import {
  FormsModule,
  ReactiveFormsModule,
  UntypedFormBuilder,
  UntypedFormControl,
  UntypedFormGroup,
  Validators
} from '@angular/forms';
import {MatAutocomplete, MatAutocompleteTrigger, MatOption} from '@angular/material/autocomplete';
import {MatButton, MatIconButton} from '@angular/material/button';
import {MatDivider} from '@angular/material/divider';
import {MatFormField, MatHint, MatLabel, MatSuffix} from '@angular/material/form-field';
import {MatInput} from '@angular/material/input';
import {MatSelect} from '@angular/material/select';
import {BreadcrumbComponent} from '@shared/components/breadcrumb/breadcrumb.component';
import {MatCheckbox, MatCheckboxChange} from '@angular/material/checkbox';
import {CatalogsService} from '@core/http/catalogs.service';
import {DefaultResponse} from '@core/models/Http/DefaultResponse';
import {
  BehaviorSubject,
  debounceTime,
  distinctUntilChanged,
  firstValueFrom,
  Subject,
  tap,
  switchMap,
  of,
  forkJoin,
  map,
  catchError
} from 'rxjs';
import {Allergy} from '@core/models/Allergy';
import {Molecule} from '@core/models/Molescule';
import {Patology} from '@core/models/Patology';
import {Medicament} from '@core/models/Medicament';
import {MatTooltip} from "@angular/material/tooltip";
import {PrescriptionSearch} from "@core/models/PrescriptionSearch";
import {PrescriptionLine} from "@core/models/PrescriptionLine";
import {PrescriptionLineService} from "@core/http/table-data-services/prescription-lines.service";
import {
  MatCell,
  MatCellDef,
  MatColumnDef,
  MatHeaderCell,
  MatHeaderCellDef,
  MatHeaderRow,
  MatHeaderRowDef,
  MatRow,
  MatRowDef,
  MatTable
} from "@angular/material/table";
import {MatCommonModule, MatRipple} from "@angular/material/core";
import {MatSort} from "@angular/material/sort";
import {FeatherIconsComponent} from "@shared/components/feather-icons/feather-icons.component";
import {MatDialog} from "@angular/material/dialog";
import {UnsubscribeOnDestroyAdapter} from "@shared";
import {PrescriptionLineComponent} from "../prescription-line/prescription-line.component";
import {PatientDetails} from "@core/models/PatientDetails";
import {PatientLine} from "@core/models/PatientLine";
import {PatientLineService} from "@core/http/table-data-services/patient-line.service";
import {SelectionModel} from "@angular/cdk/collections";
import {UserRole} from "@core/models/Enums/UserRole";
import {CreateEditService} from "@core/http/create-edit-service";
import {DoctorDetails} from "@core/models/DoctorDetails";
import {ActivatedRoute, Router} from "@angular/router";
import {PatientHistoryService} from "@core/http/table-data-services/patient-history.service";
import {MatIcon} from "@angular/material/icon";
import Swal from "sweetalert2";
import {XMLParser} from "fast-xml-parser";
import {AlertsListComponent} from "../alerts-list/alerts-list.component";
import {UppercaseNoAccentDirective} from "@shared/directives/uppercase-no-accent.directive";
import {GeneralFunctionsService} from "@core/service/generalFunctions.service";
import {MatAccordion, MatExpansionModule, MatExpansionPanel, MatExpansionPanelTitle} from "@angular/material/expansion";
import {AuthManagementService} from "@core/service/auth-management.service";
import {decryptData} from "@shared/utils/decrypt";
import {environment} from "@enviroment/environment";
import {AnalysisHtmlDialogComponent} from "@shared/analysis-html-dialog/analysis-html-dialog.component";
import {
  MedicamentoDocumentsModalComponent
} from "@shared/medicamento-documents-modal/medicamento-documents-modal.component";
import {HttpClient, HttpErrorResponse} from "@angular/common/http";
import {HttpMesageHandlerService} from "@core/service/http-mesage-handler";
import {MedicamentoTypeLabelPipe} from "@core/pipes/medicamento-type-label.pipe";
import {DoctorService} from "@core/http/table-data-services/Doctor.service";
import {PatientPinDialogComponent} from "@shared/components/patient-pin-dialog/patient-pin-dialog.component";
import {openBlankWindow} from "@shared/utils/window.utils";

interface IMedicamentoActivoPaciente {
  idReceta: string;
  idPaciente: string;
  idDetalleReceta: string;
  drugType: string;
  drug: number;
  fechaCreacion: string;
  medicamento: string;
  hide: boolean;
}

@Component({
  selector: 'app-prescription-edit-create',
  standalone: true,
  imports: [
    BreadcrumbComponent,
    FormsModule,
    MatButton,
    MatFormField,
    MatInput,
    MatLabel,
    MatDivider,
    MatOption,
    MatSelect,
    ReactiveFormsModule,
    MatAutocompleteTrigger,
    MatAutocomplete,
    MatSuffix,
    MatCheckbox,
    MatIconButton,
    MatTooltip,
    MatTable,
    MatColumnDef,
    MatHeaderCell,
    MatCell,
    MatHeaderCellDef,
    MatCellDef,
    MatHeaderRow,
    MatRow,
    MatHeaderRowDef,
    MatRowDef,
    MatRipple,
    MatSort,
    FeatherIconsComponent,
    NgClass,
    MatIcon,
    UppercaseNoAccentDirective,
    MatExpansionPanel,
    MatExpansionPanelTitle,
    MatAccordion,
    MatExpansionModule,
    MatCommonModule,
    NgIf,
    MatHint,
    NgForOf,
    MedicamentoTypeLabelPipe
  ],
  templateUrl: './prescription-edit-create.component.html',
  styleUrl: './prescription-edit-create.component.scss',
})
export class PrescriptionEditCreateComponent
  extends UnsubscribeOnDestroyAdapter
  implements OnInit, AfterViewInit {
  @ViewChild(`iframe`, {static: false}) iframe!: ElementRef;

  idMedico?: string;
  prescriptionForm: UntypedFormGroup

  prescription: PrescriptionSearch;
  prescriptionLine: PrescriptionLine;
  patient: PatientDetails;
  recibido: PatientDetails;
  patientLine: PatientLine;
  blankObject = {} as PrescriptionSearch;
  blankObjectLine = {} as PrescriptionLine;
  blankObjectPatient = {} as PatientDetails;
  blankObjectPatientLine = {} as PatientLine;

  allergies: Allergy[];
  molescules: Molecule[];
  patologies: Patology[];
  medicaments: Medicament[];
  patients: PatientDetails[];
  history: PatientLine[];

  searchPatients: string;
  htmlContent: string = '';

  keyPressAllergy$ = new Subject<string>();
  keyPressPatology$ = new Subject<string>();
  keyPressMedicament$ = new Subject<string>();
  keyPressPatient$ = new Subject<string>();

  patologiesNames: string[];
  molesculesNames: string[];
  allergiesNames: string[];
  medicamentNames: string[];
  frecuencyTypes: any[] = [];
  hasTriedSave = false;
  globalErrors: string[] = [];
  isGloballyValid = false;

  @ViewChild('panelPaciente') panelPaciente!: any;
  @ViewChild('panelConsulta') panelConsulta!: any;
  @ViewChild('panelDiagnostico') panelDiagnostico!: any;
  @ViewChild('panelMedicamentos') panelMedicamentos!: any;
  @ViewChild('validationBanner') validationBanner!: ElementRef;

  isGenderRestricted: boolean = false;
  isPregnant: boolean = false;
  isPatientLoaded: boolean = false;
  hasRelevantHistory: boolean = false;
  dataLoaded = false;
  analysisBacked = false;
  havePosted = false;

  prescriptionDataSource = new BehaviorSubject<PrescriptionLine[]>([]);
  patientDataSource = new BehaviorSubject<PatientLine[]>([]);
  patientHistoryDataSource = new BehaviorSubject<PatientLine[]>([]);
  selection = new SelectionModel<PatientLine>(true, []);

  isEditMode: boolean = false;
  recetaId?: string;
  /** ✅ Permite ocultar medicamentos (si es false, paciente tiene PIN activo) */
  canHideMedication: boolean = true;

  alertas: any;
  alertasControl: number = 0;

  medicamentosActivosPaciente: IMedicamentoActivoPaciente[] = [];
  isLoadingMedsActivos = false;
  hasHiddenMeds: boolean = false;
  showHiddenMeds: boolean = false;
  private hiddenMedsPin: string | null = null;

  // evita abrir el modal de alertas en bucle
  private autoAlertsOpened = false;

  displayedColumnsPatients: string[] = [
    'tipo',
    'nombre',
    'cronico',
    'idCode',
    'acciones',
  ];

  displayedColumns: string[] = [
    'drugType',
    'drug',
    'dose',
    'frecuency',
    'duration',
    'route',
    'indication',
    'obs',
    'documentos',
    'hide',
    'acciones',
  ];

  formControl = new UntypedFormControl('', [
    Validators.required,
  ]);
  medicamentoActivo: [] = [];
  private alergiasCronicas: number[]   = [];
  private moleculesCronicas: number[]  = [];
  private patologiasCronicas: number[] = [];


  constructor(
    private prescriptionService: PrescriptionLineService,
    private patientService: PatientLineService,
    private patientHistoryService: PatientHistoryService,
    private catalogsService: CatalogsService,
    private gfs: GeneralFunctionsService,
    private router: Router,
    public dialog: MatDialog,
    private fb: UntypedFormBuilder,
    private ceService: CreateEditService,
    private doctorService: DoctorService,
    private cd: ChangeDetectorRef,
    private http: HttpClient,
    private httpMsgHandler: HttpMesageHandlerService,
    private authManagement: AuthManagementService,
    private route: ActivatedRoute,
  ) {
    super();

    this.prescription = new PrescriptionSearch(this.blankObject);
    this.prescriptionLine = new PrescriptionLine(this.blankObjectLine);
    this.patient = new PatientDetails(this.blankObjectPatient);
    this.recibido = new PatientDetails(this.blankObjectPatient);
    this.patientLine = new PatientLine(this.blankObjectPatientLine);
    this.prescriptionForm = this.createPrescriptionForm()

    this.allergies = [];
    this.molescules = [];
    this.patologies = [];
    this.medicaments = [];
    this.patients = [];
    this.history = [];

    this.searchPatients = '';

    this.patologiesNames = [];
    this.molesculesNames = [];
    this.allergiesNames = [];
    this.medicamentNames = [];

    const userDetails = this.authManagement.userData();

    if (this.isMedicoLikeUser()) {
      this.doctorService.getDoctorByIdUser(userDetails.IdUsuario).subscribe({
        next: (res: DefaultResponse<DoctorDetails>) => {
          this.idMedico = res?.data?.idMedico;
        },
        error: () => {
          this.idMedico = undefined;
        }
      });
    }

    const navigation = this.router.getCurrentNavigation();
    if (navigation?.extras.state) {
      this.recibido = navigation.extras.state['row'];
    }
  }

  ngOnInit(): void {
    this.prescriptionDataSource = this.prescriptionService.dataChange;
    this.patientDataSource = this.patientService.dataChange;
    this.patientHistoryDataSource = this.patientHistoryService.dataChange;

    this.prescriptionService.resetPrescriptionDataSource();
    this.patientService.resetDataSource();
    this.patientHistoryService.resetDataSource();
    this.medicamentoActivo = [];
    this.havePosted = false;
    this.analysisBacked = false;
    this.getFrecuencyTypes();

    this.prescriptionForm.get('gender')?.valueChanges.subscribe((value) => {
      this.updateDependentFields(value);
    });

    this.prescriptionForm.get('pregnancy')?.valueChanges.subscribe((isPregnant) => {
      this.handlePregnancyChange(isPregnant);
    });

    this.prescriptionService.htmlResponseSubject.subscribe(html => {

      if (this.dialog.openDialogs.length > 0) {
        this.dialog.closeAll();
      }

      this.dialog.open(AnalysisHtmlDialogComponent, {
        data: html,
        panelClass: 'vademecum-dialog',
        autoFocus: false,
        restoreFocus: false,
        width: '42vw',
        height: '88vh',
        maxWidth: '85vw',
        maxHeight: '100vh'
      });
    });

    this.keyPressAllergy$
      .pipe(
        debounceTime(1000),
        distinctUntilChanged(),
        switchMap((term: string) => {
          if (!this.isValidSearchTerm(term)) {
            this.clearAlergies();
            return of(null);
          }
          return this.searchAllergiesByName(term);
        })
      )
      .subscribe();

    this.keyPressPatology$
      .pipe(
        debounceTime(1000),
        distinctUntilChanged(),
        switchMap((term: string) => {
          if (!this.isValidSearchTerm(term)) {
            this.patologies = [];
            return of([]);
          }
          return this.searchPatologiesByName(term);
        })
      )
      .subscribe();

    this.keyPressMedicament$
      .pipe(
        debounceTime(1000),
        distinctUntilChanged(),
        switchMap((term: string) => {
          if (!this.isValidSearchTerm(term)) {
            this.medicaments = [];
            return of([]);
          }
          return this.searchMedicamentsByName(term);
        })
      )
      .subscribe();

    this.keyPressPatient$
      .pipe(
        debounceTime(1000),
        distinctUntilChanged(),
        switchMap((term: string) => {
          if (!this.isValidSearchTerm(term)) {
            this.patients = [];
            this.patient = new PatientDetails(this.blankObjectPatient);
            this.isPatientLoaded = false;
            return of([]);
          }
          return this.searchPatientByName(term);
        })
      )
      .subscribe();

    const idRecetaParam = this.route.snapshot.paramMap.get('idReceta');
    const idPacienteParam = this.route.snapshot.paramMap.get('idPaciente');

    const idReceta = idRecetaParam ? atob(idRecetaParam) : '';
    const idPaciente = idPacienteParam ? atob(idPacienteParam) : '';

    if (idReceta && idPaciente) {
      this.isEditMode = true;
      this.recetaId = idReceta;
      this.cargarRecetaParaEditar(idReceta, idPaciente);
    }

    this.wireGlobalValidationLive();
    this.canSave();
  }

  private isMedicoLikeUser(): boolean {
    const userDetails = this.authManagement.userData();

    return userDetails?.TipoUsuario == UserRole.Medico ||
      userDetails?.TipoUsuario == UserRole.Particular;
  }

  private resetAutoAlerts(): void {
    this.autoAlertsOpened = false;
  }

  private runAnalysisAfterEditLoad(): void {
    const lines = this.prescriptionDataSource.getValue() ?? [];

    // Solo analizar si hay medicamentos analizables (no parafarmacia)
    const hasAnalysableLines = lines.some(l => String(l.drug ?? '').trim() !== '0');

    if (!hasAnalysableLines) {
      this.alertas = [];
      this.alertasControl = 0;
      this.medicamentoActivo = [];
      return;
    }

    this.resetAutoAlerts();

    // Espera un tick para asegurar que Angular ya pintó y los dataSource quedaron actualizados
    setTimeout(() => {
      this.confirmAdd(2).then();
    }, 0);
  }

  public loadMedicamentosActivosPaciente(idPaciente?: string, pin?: string | null): void {
    if (!idPaciente) {
      this.medicamentosActivosPaciente = [];
      this.hasHiddenMeds = false;
      this.showHiddenMeds = false;
      this.hiddenMedsPin = null;
      return;
    }

    const url = `${environment.backend_url}DetalleRecetas/GetSoloMedicamentosActivos`;
    this.isLoadingMedsActivos = true;

    const params: any = { idPaciente };
    if (pin && pin.trim().length > 0) params.pin = pin.trim();

    this.http.get<any>(url, { params }).subscribe({
      next: (res) => {
        const raw = typeof res === 'string' ? JSON.parse(res) : res;
        const data = raw?.data ?? raw ?? {};

        const hasHidden = Boolean(data?.hasHidden ?? data?.HasHidden ?? false);
        const meds = data?.medicamentos ?? data?.Medicamentos ?? [];

        this.hasHiddenMeds = hasHidden;
        this.showHiddenMeds = !!(pin && pin.trim().length > 0);
        this.hiddenMedsPin = this.showHiddenMeds ? (pin ?? null) : null;

        this.medicamentosActivosPaciente = Array.isArray(meds) ? meds : [];
        this.isLoadingMedsActivos = false;
      },
      error: (err) => {
        this.medicamentosActivosPaciente = [];
        this.showHiddenMeds = false;
        this.hiddenMedsPin = null;
        this.isLoadingMedsActivos = false;
        this.httpMsgHandler.handleMsg(err);
      }
    });
  }

  async toggleMedicamentosOcultos(): Promise<void> {
    if (!this.patient?.idPaciente) return;

    // Si ya está mostrando ocultos, volver a normal (sin pin)
    if (this.showHiddenMeds) {
      this.showHiddenMeds = false;
      this.hiddenMedsPin = null;
      this.loadMedicamentosActivosPaciente(this.patient.idPaciente, null);
      return;
    }
    const mode = 'MEDICAMENTOS_OCULTOS';

    const dialogRef = this.dialog.open(PatientPinDialogComponent, {
      disableClose: false,
      autoFocus: false,
      width: '560px',
      maxWidth: '92vw',
      panelClass: ['rmd-pin-dialog-panel'],
      data: { mode },
    });

    const pin = await firstValueFrom(dialogRef.afterClosed());

    // mismo patrón: si undefined => cancelar (no hacer nada)
    if (pin === undefined as any) return;

    const pinClean = (pin ?? '').toString().trim();

    // Si el usuario cerró o mandó vacío, no hacemos nada
    if (!pinClean) return;

    this.loadMedicamentosActivosPaciente(this.patient.idPaciente, pinClean);
  }

  getTipoMedicamentoLabel(t: string | undefined | null): string {
    const v = (t ?? '').toString().toUpperCase();
    if (v.includes('PRODUCT')) return 'PRODUCTO';
    if (v.includes('PARAFARMACIA')) return 'PARAFARMACIA';
    return v || '—';
  }

  formatFechaCorta(iso: string | undefined | null): string {
    if (!iso) return '—';
    const d = new Date(iso);
    if (isNaN(d.getTime())) return iso;
    // MX: dd/mm/yyyy hh:mm
    const dd = String(d.getDate()).padStart(2, '0');
    const mm = String(d.getMonth() + 1).padStart(2, '0');
    const yy = d.getFullYear();
    const hh = String(d.getHours()).padStart(2, '0');
    const mi = String(d.getMinutes()).padStart(2, '0');
    return `${dd}/${mm}/${yy} ${hh}:${mi}`;
  }


  getFrecuencyTypes(): void {
    const url = `${environment.backend_url}RecetaCatalogos/frecuency-types`;

    this.http.get<any[]>(url).subscribe({
      next: (response: any) => {
        this.frecuencyTypes = response.data;
      },
      error: (error: HttpErrorResponse) => {
        this.httpMsgHandler.handleMsg(error);
      }
    });
  }

  /** ✅ Alterna el flag hide por renglón (si el paciente NO tiene PIN activo) */
  toggleHideRow(index: number, row?: any): void {
    if (!this.canHideMedication) {
      Swal.fire(
        'ADVERTENCIA',
        'NO SE PUEDE OCULTAR ESTE MEDICAMENTO PORQUE EL PACIENTE NO TIENE UN PIN ACTIVO.',
        'warning'
      );
      return;
    }

    const line = row ?? this.prescriptionService.data[index];
    if (!line) return;

    line.hide = !Boolean(line.hide);
    this.prescriptionService.dataChange.next([...this.prescriptionService.data]);
  }

  canSave(autoExpandPanels = false): boolean {
    const errs: string[] = [];

    // === PACIENTE seleccionado ===
    if (!this.isPatientLoaded || !this.patient?.idPaciente) {
      errs.push('PACIENTE → SELECCIONA UN PACIENTE.');
    }

    // === PERFIL (peso/altura) ===
    const weight = Number(this.prescriptionForm.get('weight')?.value ?? 0);
    const height = Number(this.prescriptionForm.get('height')?.value ?? 0);
    if (!weight || weight <= 0) errs.push('PERFIL → FALTA PESO (> 0).');
    if (!height || height <= 0) errs.push('PERFIL → FALTA ALTURA (> 0).');

    // === DIAGNOSTICO: al menos 1 ===
    const diagCount = (this.patientDataSource?.getValue()?.length ?? 0);
    if (diagCount === 0) {
      errs.push('DIAGNOSTICO → AGREGA AL MENOS UNA PATOLOGIA/ALERGIA/MOLECULA.');
    }

    // === MEDICAMENTOS: al menos 1 y sin posologia faltante ===
    const lines = this.prescriptionDataSource?.getValue() ?? [];
    if (lines.length === 0) {
      errs.push('MEDICAMENTOS → AGREGA AL MENOS UN MEDICAMENTO.');
    } else {
      const incompletos = lines
        .map(l => ({ line: l, faltan: this.getMissingPosologyFields(l) }))
        .filter(x => x.faltan.length > 0);

      incompletos.forEach(x => {
        const nombre =
          (x.line?.summary ||
            x.line?.name ||
            (x.line as any)?.medicamentoNombre ||
            'MEDICAMENTO'
          ).toString();
        errs.push(`MEDICAMENTOS → ${nombre}: faltan ${x.faltan.join(', ')}.`);
      });
    }

    this.globalErrors = errs;
    this.isGloballyValid = errs.length === 0;

    if (autoExpandPanels && this.hasTriedSave) {
      if (errs.some(e => e.startsWith('PACIENTE') || e.startsWith('PERFIL'))) {
        this.panelPaciente?.open();
        this.panelConsulta?.open();
      }
      if (errs.some(e => e.startsWith('DIAGNOSTICO'))) this.panelDiagnostico?.open();
      if (errs.some(e => e.startsWith('MEDICAMENTOS'))) this.panelMedicamentos?.open();
    }

    return this.isGloballyValid;
  }

  /** Suscripciones para ir limpiando el banner despues del primer intento */
  private wireGlobalValidationLive(): void {
    this.prescriptionForm.valueChanges.pipe(debounceTime(150)).subscribe(() => this.canSave(false));
    this.patientDataSource.subscribe(() => this.canSave(false));
    this.prescriptionDataSource.subscribe(() => this.canSave(false));
  }

  get hasValidPatientProfile(): boolean {
    const weight = Number(this.prescriptionForm.get('weight')?.value ?? 0);
    const height = Number(this.prescriptionForm.get('height')?.value ?? 0);

    return weight > 0 && height > 0;
  }

  get missingPatientProfileFields(): string[] {
    const missing: string[] = [];
    const weight = Number(this.prescriptionForm.get('weight')?.value ?? 0);
    const height = Number(this.prescriptionForm.get('height')?.value ?? 0);

    if (!weight || weight <= 0) missing.push('PESO');
    if (!height || height <= 0) missing.push('ALTURA');

    return missing;
  }

  get hasClinicalContext(): boolean {
    return (this.patientDataSource?.getValue()?.length ?? 0) > 0;
  }

  get canUseDiagnosticsSearch(): boolean {
    return this.hasValidPatientProfile;
  }

  get canUseMedicationSearch(): boolean {
    return this.hasValidPatientProfile && this.hasClinicalContext;
  }

  get diagnosticsLockMessage(): string {
    const missing = this.missingPatientProfileFields;

    if (missing.length === 1) {
      return `PARA UN ANALISIS CORRECTO Y COMPLETO, CAPTURA ${missing[0]} DEL PACIENTE ANTES DE AGREGAR PATOLOGIAS, ALERGIAS O MOLECULAS.`;
    }

    return 'PARA UN ANALISIS CORRECTO Y COMPLETO, CAPTURA PESO Y ALTURA DEL PACIENTE ANTES DE AGREGAR PATOLOGIAS, ALERGIAS O MOLECULAS.';
  }

  get medicationLockMessage(): string {
    const pending: string[] = [...this.missingPatientProfileFields];

    if (!this.hasClinicalContext) {
      pending.push('AL MENOS UNA PATOLOGIA, ALERGIA O MOLECULA EN DIAGNOSTICO');
    }

    if (pending.length === 1) {
      return `PARA UN ANALISIS CORRECTO Y COMPLETO, CAPTURA ${pending[0]} ANTES DE BUSCAR MEDICAMENTOS.`;
    }

    if (pending.length === 2) {
      return `PARA UN ANALISIS CORRECTO Y COMPLETO, CAPTURA ${pending[0]} Y ${pending[1]} ANTES DE BUSCAR MEDICAMENTOS.`;
    }

    const last = pending[pending.length - 1];
    const first = pending.slice(0, -1).join(', ');
    return `PARA UN ANALISIS CORRECTO Y COMPLETO, CAPTURA ${first} Y ${last} ANTES DE BUSCAR MEDICAMENTOS.`;
  }

  private validateBeforeAnalysis(): boolean {
    this.hasTriedSave = true;
    this.canSave(true);

    if (!this.isGloballyValid) {
      setTimeout(() => {
        this.validationBanner?.nativeElement?.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }, 0);
    }

    return this.isGloballyValid;
  }

  async onSubmit(): Promise<void> {
    // primer click: habilita el modo "mostrar banner si falta algo"
    if (!this.hasTriedSave) this.hasTriedSave = true;

    this.canSave(true);

    // Si no es valido, mostrar banner y hacer scroll
    if (!this.isGloballyValid) {
      setTimeout(() => {
        this.validationBanner?.nativeElement?.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }, 0);
      return;
    }

    // Ya valido → guardar/actualizar
    if (this.isEditMode) {
      await this.actualizarReceta();
    } else {
      await this.crearReceta();
    }
  }

  private pushToDiagnosis(detailType: 'Alergia' | 'Molecula' | 'Patologia',
                          name: string, id: number, code: string = '', cronical = false): PatientLine {
    const typeMap = { Alergia: 1, Molecula: 2, Patologia: 3 } as const;
    const newLine: PatientLine = new PatientLine({
      detailType,
      detailTypeName: name,
      cronical,
      detailTypeId: id,
      type: typeMap[detailType],
      detailTypeCode: code,
    });
    this.patientService.addPatientLine(newLine);
    return this.patientService.data[this.patientService.data.length - 1];
  }

  private cargarRecetaParaEditar(idReceta: string, idPaciente: string): void {
    const url  = `${environment.backend_url}Recetas/GetRecetaUpdateByIdReceta`;
    const body = { idReceta, idPaciente };

    this.http.post<any>(url, body, { headers: { 'Content-Type': 'application/json' } })
      .subscribe({
        next: (res) => {
          // Soporta { receta, detalles } o { data:{...} } o string
          const raw      = typeof res === 'string' ? JSON.parse(res) : res;
          const data     = raw?.data ?? raw ?? {};
          const receta   = data?.receta;
          const detalles = data?.detalles ?? [];

          if (!receta) {
            Swal.fire('ERROR', 'RESPUESTA INVALIDA DEL SERVIDOR (SIN RECETA).', 'error');
            return;
          }

          this.idMedico = receta.idMedico ?? this.idMedico ?? null;

          // ===== Paciente (solo datos basicos para cabecera) =====
          this.patient = {
            ...this.blankObjectPatient,
            idPaciente: receta.idPaciente,
            nombres: `${receta.nombresPaciente ?? ''} ${receta.primerApellidoPaciente ?? ''} ${receta.segundoApellidoPaciente ?? ''}`.trim(),
            genero: receta.genero,                // 'M' | 'F'
            edad: receta.edadPaciente,
            fechaNacimiento: receta.fechaNacimiento,
            alergias: receta.alergias ?? [],      // ← no se usan para antecedentes
            molecules: receta.molecules ?? [],    // ← no se usan para antecedentes
            patologias: receta.patologias ?? [],   // ← no se usan para antecedentes
          } as PatientDetails;

          // Mostrar datos del paciente (oculta buscador)
          this.isPatientLoaded = true;
          this.loadMedicamentosActivosPaciente(receta.idPaciente, null);
          this.resetAutoAlerts();
          this.prescriptionForm.patchValue({ dateOfBirth: receta.fechaNacimiento });

          // ===== Form principal =====
          this.prescriptionForm.patchValue({
            gender: (receta.genero === 'M' ? 'M' : 'F'),
            weight: receta.pacPeso ?? null,
            height: receta.pacTalla ?? null,
            creatin: receta.pacCreatinina ?? 120,
            pregnancy: !!receta.pacEmbarazo,
            weeksOfAmenorrhea: receta.pacSemAmenorrea ?? null,
            breastFeeding: receta.pacLactancia ? 'ALL' : 'NONE'
          });
          this.refreshAgeDisplayFromDob(receta.fechaNacimiento);
          this.updateDependentFields(this.prescriptionForm.get('gender')?.value);
          this.handlePregnancyChange(!!receta.pacEmbarazo);

          // ===== Antecedentes: reset y (AHORA) se cargaran desde /api/Pacientes =====
          this.patientHistoryService.resetDataSource();

          // ===== Diagnostico de la consulta (tabla lateral) =====
          this.patientService.resetDataSource();

          // Patologias (diagnostico actual)
          (receta.patologias ?? []).forEach((p: any) => {
            const newLine: PatientLine = new PatientLine({
              detailType: 'Patologia',
              detailTypeName: p?.nameCIM10 ?? p?.name ?? '',
              cronical: false,
              detailTypeId: p?.idCIM10 ?? p?.id ?? 0,
              type: 3,
              detailTypeCode: p?.code ?? ''
            });
            this.patientService.addPatientLine(newLine);
          });

          // Alergias (diagnostico actual)
          (receta.alergias ?? []).forEach((a: any) => {
            const id   = a?.idAllergy ?? a?.id ?? a;
            const name = a?.nameAllergy ?? `ALERGIA #${id}`;
            const newLine: PatientLine = new PatientLine({
              detailType: 'Alergia',
              detailTypeName: name,
              cronical: false,
              detailTypeId: id,
              type: 1,
              detailTypeCode: ''
            });
            this.patientService.addPatientLine(newLine);
          });

          // Moleculas (diagnostico actual)
          (receta.molecules ?? []).forEach((m: any) => {
            const id   = m?.idMolecule ?? m?.id ?? m;
            const name = m?.nameMolecule ?? `MOLECULA #${id}`;
            const newLine: PatientLine = new PatientLine({
              detailType: 'Molecula',
              detailTypeName: name,
              cronical: false,
              detailTypeId: id,
              type: 2,
              detailTypeCode: ''
            });
            this.patientService.addPatientLine(newLine);
          });

          // ===== Detalles -> tabla medicamentos =====
          this.prescriptionService.resetPrescriptionDataSource();
          (detalles as any[]).forEach((d) => {
            const isParafarmacia = d.medicamentoType === 'PARAFARMACIA' || d.medicamentoId === 0;

            const line: any = new PrescriptionLine({
              drugType: isParafarmacia ? 'PARAFARMACIA' : 'PRODUCT',
              drug: isParafarmacia ? '0' : String(d.medicamentoId),
              name: d.medicamentoNombre ?? '',
              summary: d.medicamentoNombre ?? '',
              dose: d.cantidadDiaria ?? 0,
              unitId: d.unidadDispensacionId ?? 0,
              unitIdName: d.unidadDispensacion ?? '',
              duration: d.duracion ?? 0,
              durationType: this.mapUnidadDuracionToType(d.unidadDuracion),
              durationName: d.unidadDuracion ?? '',
              route: d.rutaAdministracionId ?? 0,
              routeName: d.rutaAdministracion ?? '',
              indication: Number(d.indicacion ?? 0),
              indicationName: d.indicacionNombre ?? '',
              frecuency: d.frecuency ?? 0,
              frecuencyType: d.frecuencyType ?? '',
              idFrecuencyType: d.idFrecuencyType ?? 0,
              obs: d.observaciones ?? '',
              hide: Boolean(d.hide ?? false),
              showNoAnalysisLegend: isParafarmacia
            });

            // Para PUT (ActualizarReceta) parapharmacia acepta idDetalleReceta
            (line as any).idDetalleReceta = d.idDetalleReceta ?? null;

            this.prescriptionService.addPrescriptionLine(line);
          });

          this.validateIncompleteOnLoad(detalles);

          // Recalcular alertas si corresponde
          this.checkAlertsControl();

          this.fetchAntecedentesCronicos(receta.idPaciente /*, receta.idUsuario */)
            .subscribe({
              next: (ant) => {
                this.syncCronicosConUI(ant);
                this.runAnalysisAfterEditLoad();
              },
              error: () => {
                // Aunque falle la carga de antecedentes, intentamos correr el análisis
                this.runAnalysisAfterEditLoad();
              }
            });
        },
        error: (err) => {
          this.httpMsgHandler.handleMsg(err);
        }
      });
  }

  hasParafarmacia(): boolean {
    return (this.prescriptionService.data || []).some((row: any) =>
      this.isParafarmaciaRow(row)
    );
  }

  private mapUnidadDuracionToType(label: string | undefined): string {
    if (!label) return 'DAY';
    const t = label.toUpperCase();
    if (t.includes('AÑO')) return 'YEAR';
    if (t.includes('MES')) return 'MONTH';
    if (t.includes('SEMANA')) return 'WEEK';
    if (t.includes('HORA')) return 'HOUR';
    if (t.includes('MIN')) return 'MINUTE';
    return 'DAY';
  }

  public async actualizarReceta(): Promise<void> {
    if (!this.isEditMode || !this.recetaId) return;

    if (!this.isGloballyValid && !this.hasTriedSave) {
      this.hasTriedSave = true;
      this.canSave();
      return;
    }

    if (!this.isGloballyValid) {
      return;
    }

    const idPacienteFinal = (this.patient?.idPaciente ?? '').toString().trim();
    if (!idPacienteFinal) {
      Swal.fire(
        'ERROR',
        'NO SE PUDO OBTENER EL ID DEL PACIENTE PARA ACTUALIZAR LA RECETA.',
        'error'
      ).then();
      return;
    }

    const now = new Date().toISOString();

    const { patologias, alergias, moleculas } = this.createExtracted();
    const { patologiasCronicas, alergiasCronicas, moleculasCronicas } = this.cronicalExtracted();

    const prescription = this.prescriptionForm.getRawValue();
    const lines = (this.prescriptionDataSource.getValue() ?? []) as any[];

    // ✅ lineas normales
    const prescriptionLines = lines
      .filter(line => {
        const drug = String(line?.drug ?? '').trim();
        const drugType = String(line?.drugType ?? '').trim().toUpperCase();
        return drug !== '0' && drugType !== 'PARAFARMACIA';
      })
      .map(line => ({
        idMedicamento: Number(line.drug) || 0,
        tipoMedicamento: line.drugType ?? 'PRODUCT',
        unidadDispensacionId: Number(line.unitId ?? 0),
        rutaAdministracionId: Number(line.route ?? 0),
        indicacion: String(line.indication ?? ''),
        indicacionNombre: line.indicationName ?? '',
        frecuency: Number(line.frecuency ?? 0),
        idFrecuencyType: Number(line.idFrecuencyType ?? 0),
        frecuencyType: line.frecuencyType ?? '',
        observaciones: line.obs ?? '',
        cantidadDiaria: Number(line.dose ?? 0),
        duracion: Number(line.duration ?? 0),
        unidadDuracion: line.durationType ?? '',
        periodoInicio: now,
        periodoTerminacion: this.calculatePeriodEndDate(
          Number(line.duration ?? 0),
          line.durationType ?? 'DAY'
        ),
        hide: Boolean(line.hide ?? false)
      }));

    // ✅ lineas de parafarmacia
    const paraFarmaciaLine = lines
      .filter(line => {
        const drug = String(line?.drug ?? '').trim();
        const drugType = String(line?.drugType ?? '').trim().toUpperCase();
        return drug === '0' || drugType === 'PARAFARMACIA';
      })
      .map(line => ({
        idDetalleReceta: line.idDetalleReceta ?? null,
        idMedicamento: 0,
        tipoMedicamento: 'PARAFARMACIA',
        descripcionParaFarmacia: line.summary ?? line.name ?? '',
        cantidadDiaria: Number(line.dose ?? 0),
        unidadDispensacionId: Number(line.unitId ?? 0),
        rutaAdministracionId: Number(line.route ?? 0),
        indicacion: '',
        duracion: Number(line.duration ?? 0),
        unidadDuracion: line.durationType ?? '',
        periodoInicio: now,
        periodoTerminacion: this.calculatePeriodEndDate(
          Number(line.duration ?? 0),
          line.durationType ?? 'DAY'
        ),
        fechaSurtido: null,
        indicacionNombre: '',
        frecuency: Number(line.frecuency ?? 0),
        idFrecuencyType: Number(line.idFrecuencyType ?? 0),
        observaciones: line.obs ?? '',
        hide: Boolean(line.hide ?? false)
      }));

    const payload = {
      idMedico: null,
      idPaciente: idPacienteFinal,
      paciente: {
        peso: Number(prescription.weight ?? 0),
        talla: Number(prescription.height ?? 0),
        embarazo: Boolean(prescription.pregnancy),
        semanasAmenorrea: Number(prescription.weeksOfAmenorrhea ?? 0),
        lactancia: prescription.breastFeeding === 'ALL',
        creatinina: Number(prescription.creatin ?? 120),
        alergias: alergias ?? [],
        moleculas: moleculas ?? [],
        patologias: patologias ?? []
      },
      prescriptionLines,
      paraFarmaciaLine,
      patologiasCronicas: patologiasCronicas ?? [],
      alergiasCronicas: alergiasCronicas ?? [],
      moleculasCronicas: moleculasCronicas ?? [],
      folio: '',
      idReceta: this.recetaId
    };

    const url = `${environment.backend_url}Recetas/ActualizarReceta`;
    const cleanData = this.gfs.mayusAcentos(payload);

    this.http.put(url, cleanData, {
      headers: { 'Content-Type': 'application/json' }
    }).subscribe({
      next: () => {
        Swal.fire('EXITO', 'RECETA ACTUALIZADA CON EXITO', 'success').then(() => {
          this.router.navigate(['prescription/prescription-list']).then();
        });
      },
      error: (err) => {
        this.httpMsgHandler.handleMsg(err);
      }
    });
  }

  checkRelevantHistory(patient: PatientDetails): boolean {
    return (
      patient?.molecules?.length > 0 ||
      patient?.alergias?.length > 0 ||
      patient?.patologias?.length > 0
    );
  }

  openHtmlModal(html: string): void {
    this.htmlContent = html;
    this.dataLoaded = true;
  }

  getErrorMessage() {
    return this.formControl.hasError('required')
      ? 'CAMPO REQUERIDO'
      : this.formControl.hasError('email')
        ? 'CORREO INVALIDO'
        : 'ERROR'
  }

  createPrescriptionForm(): UntypedFormGroup {
    return this.fb.group({
      gender: [null],
      dateOfBirth: [null],
      weight: [null, [Validators.required, Validators.min(0.01)]],
      height: [null, [Validators.required, Validators.min(0.01)]],
      breastFeeding: [null],
      weeksOfAmenorrhea: [null],
      pregnancy: [false],
      creatin: [120],
      molecules: [[]],
      allergies: [[]],
      pathologies: [[]],

      age: [''],
      medicaments: [null],
      searchMoleculesChecked: [true],
      searchAllergiesChecked: [true],
      searchPatologies: [''],
      searchAllergies: [''],
      searchMedicaments: ['']
    });
  }

  searchAllergiesByKeyPress() {
    const raw = this.prescriptionForm.get('searchAllergies')?.value;
    const term = typeof raw === 'string' ? raw.trim() : '';

    if (!term) {
      this.allergies = [];
      this.molescules = [];
      return;
    }

    this.keyPressAllergy$.next(term);
  }

  searchPatologiesByKeyPress() {
    const raw = this.prescriptionForm.get('searchPatologies')?.value;
    const term = typeof raw === 'string' ? raw.trim() : '';

    if (!term) {
      this.patologies = [];
      return;
    }

    this.keyPressPatology$.next(term);
  }

  searchMedicamentsByKeyPress() {
    if (!this.canUseMedicationSearch) {
      this.medicaments = [];
      this.prescriptionForm.patchValue({ searchMedicaments: '' }, { emitEvent: false });
      return;
    }

    const raw = this.prescriptionForm.get('searchMedicaments')?.value;
    const term = typeof raw === 'string' ? raw.trim() : '';

    if (!term) {
      this.medicaments = [];
      return;
    }

    this.keyPressMedicament$.next(term);
  }

  searchPatientsByKeyPress() {
    const term = (this.searchPatients ?? '').toString().trim();

    if (!term) {
      this.patients = [];
      return;
    }

    this.keyPressPatient$.next(term);
  }

  displayFnAllergy(option: any): string {
    return option && option.nameAllergy
      ? option.nameAllergy
      : (option.nameMolecule ? option.nameMolecule : '');
  }

  displayFnPatologies(patology: Patology): string {
    return patology && patology.nameCIM10 ? patology.nameCIM10 : '';
  }

  displayFnMedicaments(medicament: Medicament): string {
    return medicament && medicament.nombre ? medicament.nombre + ' - ' + medicament.idType : '';
  }

  displayFnPatients(patient: PatientDetails): string {
    return patient && patient.nombres ?
      patient.nombres + ' ' + patient.primerApellido + ' ' + patient.segundoApellido : '';
  }

  setSelectedAllergy(value: any) {
    if (value) {

      if (value) {
        if (!this.history) {
          this.history = [];
        }
        const exists = this.history.find((a) => a == value);

        if (!exists) {
          this.history.push(value);
          this.addNewPatientLine(value);
          this.prescriptionForm.patchValue({'searchAllergies': ''})
        }
      }
    }
  }

  setSelectedPatology(value: any) {
    if (value) {

      if (value) {
        if (!this.history) {
          this.history = [];
        }
        const exists = this.history.find((a) => a == value);

        if (!exists) {
          this.history.push(value);
          this.addNewPatientLine(value);
          this.prescriptionForm.patchValue({'searchPatologies': ''})
        }
      }
    }
  }

  setSelectedMedicamente(value: any) {
    if (!this.canUseMedicationSearch) {
      return;
    }

    if (value && value.idType === 'PRODUCT' && environment.region == "ES") {
      this.http.post<any>(
        `${environment.backend_url}VIDAL_CIM10/AskPSumistroByIdProduct`,
        JSON.stringify({ idProduct: value.id }),
        {
          headers: {'Content-Type': 'application/json'},
          responseType: 'json'
        }
      ).subscribe({
        next: (hasIssue) => {
          if (hasIssue.data === true) {
            this.http.post<any>(
              `${environment.backend_url}VIDAL_CIM10/GetPSumistroByIdProduct`,
              JSON.stringify({ idProduct: value.id }),
              {
                headers: {'Content-Type': 'application/json'},
                responseType: 'json'
              }
            ).subscribe({
              next: (detailString) => {
                // Parsear el objeto y luego la propiedad 'data'
                const detailObj = (typeof detailString === 'string') ? JSON.parse(detailString) : detailString;
                const detail = JSON.parse(detailObj.data);

                Swal.fire({
                  icon: 'error',
                  title: 'PROBLEMA DE SUMINISTRO',
                  html: `
                  <div style="text-align:left;">
                    <b>Medicamento:</b> ${detail.medicamento || value.nombre}<br>
                    <b>Codigo Nacional:</b> ${detail.codigoNacional || ''}<br>
                    <b>Fecha de inicio:</b> ${detail.fechaInicio || ''}<br>
                    <b>Fecha fin:</b> ${detail.ffin || ''}<br>
                    <b>Observaciones:</b> ${detail.observ || ''}<br>
                    ${detail.imagen ? `<img src="${detail.imagen}" alt="alerta" style="max-width:120px;display:block;margin-top:8px;">` : ''}
                  </div>
                `
                }).then();
                this.prescriptionForm.patchValue({'searchMedicaments': ''});
              },
              error: () => {
                Swal.fire(
                  'ERROR',
                  `No se pudo obtener el detalle de suministro del medicamento "${value.nombre}".`,
                  'error'
                ).then();
                this.prescriptionForm.patchValue({'searchMedicaments': ''});
              }
            });
          } else {
            // --- Logica original (agregar medicamento) ---
            if (this.prescriptionService.isLineValid()) {
              if (value) {
                if (!this.prescription.medicamentos) {
                  this.prescription.medicamentos = [];
                }

                const exists = this.prescription.medicamentos.find((a) => a == String(value.id));

                if (!exists) {
                  this.prescription.medicamentos.push(String(value.id));
                  this.medicamentNames.push(value.nombre);
                  this.addNewLine(value);
                }
              }
            } else {
              this.showPosologyIncompleteSwal();
            }
          }
        },
        error: () => {
          Swal.fire(
            'ERROR',
            `No se pudo validar el suministro del medicamento "${value.nombre}". Intente de nuevo.`,
            'error'
          ).then();
          this.prescriptionForm.patchValue({'searchMedicaments': ''});
        }
      });
    } else {
      // Logica original si no es PRODUCT
      if (this.prescriptionService.isLineValid()) {
        if (value) {
          if (!this.prescription.medicamentos) {
            this.prescription.medicamentos = [];
          }

          const exists = this.prescription.medicamentos.find((a) => a == String(value.id));

          if (!exists) {
            this.prescription.medicamentos.push(String(value.id));
            this.medicamentNames.push(value.nombre);
            this.addNewLine(value);
          }
        }
      } else {
        this.showPosologyIncompleteSwal();
      }
    }
  }

  /** Devuelve los campos faltantes de una linea.
   *  Soporta shape de tabla (this.prescriptionService.data) y shape de "detalles" del backend.
   *  Omite validacion de Motivo de uso para PARAFARMACIA.
   */
  private getMissingPosologyFields(line: any): string[] {
    const falta: string[] = [];
    const num = (v: any) => Number(v);
    const str = (v: any) => (v ?? '').toString().trim();

    const isParafarmacia =
      (line?.drugType === 'PARAFARMACIA') ||
      (String(line?.drug ?? '') === '0') ||
      (line?.medicamentoType === 'PARAFARMACIA') ||
      (Number(line?.idMedicamento) === 0);

    // Normalizacion
    const dose         = line?.dose ?? line?.cantidadDiaria;
    const unitId       = line?.unitId ?? line?.unidadDispensacionId;
    const duration     = line?.duration ?? line?.duracion;
    const durationType = line?.durationType ?? line?.unidadDuracion;
    const route        = line?.route ?? line?.rutaAdministracionId;
    const frecuency    = line?.frecuency;
    const idFreqType   = line?.idFrecuencyType;

    // ✅ INFERENCIA REAL (sin perdonar de mas, pero sin romper cuando no viene el flag)
    const unitsArr  = Array.isArray(line?.units)  ? line.units  : null;
    const routesArr = Array.isArray(line?.routes) ? line.routes : null;

    const requiresUnit =
      !isParafarmacia && (
        line?.requiresUnit === true ||
        (unitsArr ? unitsArr.length > 0 : false)
      );

    const requiresRoute =
      !isParafarmacia && (
        line?.requiresRoute === true ||
        (routesArr ? routesArr.length > 0 : false)
      );

    // CANTIDAD DIARIA
    if (dose == null || isNaN(num(dose)) || num(dose) <= 0) falta.push('CANTIDAD DIARIA');

    // UNIDAD (solo si aplica)
    if (requiresUnit && (!unitId || num(unitId) === 0)) falta.push('UNIDAD DE DISPENSACION');

    // DURACION
    if (duration == null || isNaN(num(duration)) || num(duration) <= 0) falta.push('DURACION');

    // TIPO DE DURACION
    if (!str(durationType)) falta.push('TIPO DE DURACION');

    // VIA (solo si aplica)
    if (requiresRoute && (!route || num(route) === 0)) falta.push('VIA DE ADMINISTRACION');

    // FRECUENCIA
    if (frecuency == null || isNaN(num(frecuency)) || num(frecuency) <= 0) falta.push('FRECUENCIA');

    // TIPO DE FRECUENCIA
    if (!idFreqType || num(idFreqType) === 0) falta.push('TIPO DE FRECUENCIA');

    return falta;
  }


  /**
   * Muestra un Swal listando los campos faltantes por medicamento.
   * Si no se pasa "lines", toma la fuente actual (this.prescriptionService.data).
   */
  private showPosologyIncompleteSwal(lines?: any[]): void {
    const source: any[] = lines ?? (this.prescriptionService?.data ?? []);
    const incompletos = source
      .map(l => ({ line: l, faltan: this.getMissingPosologyFields(l) }))
      .filter(x => x.faltan.length > 0);

    if (incompletos.length === 0) return;

    const filas = incompletos.map(x => {
      const nombre =
        (x.line?.name || x.line?.summary || x.line?.medicamentoNombre || 'MEDICAMENTO').toString();
      const campos = x.faltan.join(', ');
      return `• <b>${nombre}</b>: faltan <i>${campos}</i>`;
    }).join('<br>');

    Swal.fire({
      icon: 'warning',
      title: 'POSOLOGIA INCOMPLETA',
      html: `
      <p>Hay <b>${incompletos.length}</b> medicamento(s) con datos faltantes.</p>
      <div style="text-align:left;margin-top:8px">${filas}</div>
    `,
      confirmButtonText: 'Entendido',
      confirmButtonColor: '#00a5b8'
    }).then(() => {
      this.prescriptionForm.patchValue({ 'searchMedicaments': '' });
    });
  }

  /** Valida los detalles cargados desde backend y muestra Swal si hay faltantes. */
  private validateIncompleteOnLoad(detalles: any[]): void {
    if (!Array.isArray(detalles) || detalles.length === 0) return;

    // Mapeo minimo para que getMissingPosologyFields entienda ambos shapes
    const normalized = detalles.map(d => ({
      // estos tres ayudan a detectar tipo y nombre en el Swal:
      medicamentoNombre: d?.medicamentoNombre ?? '',
      medicamentoType: d?.medicamentoType ?? (d?.medicamentoId === 0 ? 'PARAFARMACIA' : 'PRODUCT'),
      idMedicamento: d?.medicamentoId ?? 0,

      // campos de posologia (nombres originales del backend)
      cantidadDiaria: d?.cantidadDiaria,
      unidadDispensacionId: d?.unidadDispensacionId,
      duracion: d?.duracion,
      unidadDuracion: d?.unidadDuracion,
      rutaAdministracionId: d?.rutaAdministracionId,
      indicacion: d?.indicacion,
      indicacionNombre: d?.indicacionNombre,
      frecuency: d?.frecuency,
      idFrecuencyType: d?.idFrecuencyType,
    }));

    this.showPosologyIncompleteSwal(normalized);
  }


  setSelectedPatient(value: PatientDetails, control: number = 0) {
    if (value) {

      this.searchPatients = this.gfs.mayusAcentos(this.searchPatients);
      const cleanData = this.gfs.mayusAcentos(value);
      this.prescriptionService.resetPrescriptionDataSource();
      this.patientService.resetDataSource();
      this.patientHistoryService.resetDataSource();
      this.analysisBacked = false;
      this.havePosted = false;
      this.medicamentoActivo = [];
      this.selection.clear();
      this.alergiasCronicas = [];
      this.moleculesCronicas = [];
      this.patologiasCronicas = [];

      this.patient = cleanData;

      this.canHideMedication = Boolean(
        (cleanData as any)?.pinActivo ??
        (cleanData as any)?.PinActivo ??
        false
      );

      if (!control) {
        this.patient.nombres = cleanData.nombres + ' ' + cleanData.primerApellido + ' ' + cleanData.segundoApellido;
      }

      this.prescriptionForm.patchValue({ gender: cleanData.genero === 'M' ? 'M' : 'F' });
      // DOB real del paciente
      const dob = (cleanData as any).fechaNacimiento ?? null;

      this.prescriptionForm.patchValue({ dateOfBirth: dob }, { emitEvent: false });
      this.refreshAgeDisplayFromDob(dob);

      this.checkAlertsControl();
      if (!this.hasRelevantHistory) {
        this.hasRelevantHistory = this.checkRelevantHistory(cleanData);
      }
      if (!this.isPatientLoaded) {
        this.isPatientLoaded = true;
      }

      if (cleanData.patologias.length > 0) {
        this.processDetailLines(cleanData.patologias, 'Patologia', 'idCIM10', 3, 'nameCIM10');
      }

      if (cleanData.alergias.length > 0) {
        this.processDetailLines(cleanData.alergias, 'Alergia', 'idAllergy', 1, 'nameAllergy');
      }

      if (cleanData.molecules.length > 0) {
        this.processDetailLines(value.molecules, 'Molecula', 'idMolecule', 2, 'nameMolecule');
      }

      this.loadMedicamentosActivosPaciente(this.patient?.idPaciente, null);
      this.fetchAntecedentesCronicos(this.patient?.idPaciente).subscribe({
        next: (ant) => {
          this.syncCronicosConUI(ant);
        },
        error: () => {
          this.alergiasCronicas = [];
          this.moleculesCronicas = [];
          this.patologiasCronicas = [];
        }
      });
      this.resetAutoAlerts();
    }
  }

  get chronicFollowupAvailable(): number {
    return this.patientHistoryDataSource.getValue().length;
  }

  get shouldShowChronicFollowupImport(): boolean {
    const diagnosisKeys = new Set(
      this.patientDataSource.getValue().map(row => this.keyFromLine(row))
    );

    return this.patientHistoryDataSource.getValue()
      .some(row => !diagnosisKeys.has(this.keyFromLine(row)));
  }

  importChronicPathologiesToDiagnosis(): void {
    const chronicRows = this.patientHistoryDataSource.getValue();

    if (chronicRows.length === 0) {
      Swal.fire('AVISO', 'EL PACIENTE NO TIENE ANTECEDENTES CRONICOS PARA IMPORTAR.', 'info').then();
      return;
    }

    const currentRows = this.patientDataSource.getValue();

    let imported = 0;
    let linked = 0;

    chronicRows.forEach(row => {
      const rowKey = this.keyFromLine(row);
      let diagnosisRow = currentRows.find(current => this.keyFromLine(current) === rowKey);

      if (!diagnosisRow) {
        diagnosisRow = this.pushToDiagnosis(
          row.detailType as 'Alergia' | 'Molecula' | 'Patologia',
          row.detailTypeName,
          Number(row.detailTypeId),
          row.detailTypeCode ?? '',
          true
        );
        imported++;
      }

      if (diagnosisRow && !this.selection.isSelected(diagnosisRow)) {
        this.selection.select(diagnosisRow);
        linked++;
      }
    });

    if (imported === 0 && linked === 0) {
      Swal.fire('AVISO', 'LOS ANTECEDENTES CRONICOS YA ESTAN CARGADOS EN DIAGNOSTICO.', 'info').then();
      return;
    }

    this.patientService.dataChange.next([...this.patientService.data]);

    const importedMessage = imported > 0
      ? `SE IMPORTARON ${imported} ANTECEDENTES CRONICOS A DIAGNOSTICO.`
      : 'LOS ANTECEDENTES CRONICOS YA EXISTIAN EN DIAGNOSTICO.';
    const linkedMessage = linked > imported
      ? ' LOS YA EXISTENTES TAMBIEN QUEDARON MARCADOS COMO CRONICOS.'
      : '';

    Swal.fire('EXITO', `${importedMessage}${linkedMessage}`, 'success').then();
  }

  processDetailLines(details: any[], type: string, idField: string, codeField: number, nameField: string): void {
    details.forEach(obj => {
      const newLine: PatientLine = new PatientLine({
        detailType: type,
        detailTypeName: obj[nameField],
        cronical: false,
        detailTypeId: obj[idField],
        type: codeField,
        detailTypeCode: obj.code || '',
      });
      this.patientHistoryService.addPatientLine(newLine);
    });
  }

  searchAllergiesByName(term: string) {
    if (!term) {
      this.clearAlergies();
      return of(null);
    }

    const searchAllergies = this.prescriptionForm.get('searchAllergiesChecked')?.value;
    const searchMolecules = this.prescriptionForm.get('searchMoleculesChecked')?.value;

    const allergiesRequest = searchAllergies
      ? this.catalogsService.getAllergiesByName(term).pipe(
        map((res: DefaultResponse<Allergy[]>) =>
          (res.data ?? []).map(allergy => ({
            ...allergy,
            type: 1
          }))
        ),
        catchError(() => of([]))
      )
      : of([]);

    const moleculesRequest = searchMolecules
      ? this.catalogsService.getMolesculesByName(term).pipe(
        map((res: DefaultResponse<Molecule[]>) =>
          (res.data ?? []).map(molecule => ({
            ...molecule,
            type: 2
          }))
        ),
        catchError(() => of([]))
      )
      : of([]);

    return forkJoin({
      allergies: allergiesRequest,
      molescules: moleculesRequest
    }).pipe(
      tap(({ allergies, molescules }) => {
        this.allergies = allergies;
        this.molescules = molescules;
      }),
      catchError(() => {
        this.clearAlergies();
        return of(null);
      })
    );
  }

  clearAlergies() {
    this.allergies = [];
    this.molescules = [];
  }

  clearPatologies() {
    this.patologies = [];
  }

  clearMedicaments() {
    this.medicaments = [];
  }

  clearPatients() {
    this.patients = [];
  }

  searchPatologiesByName(term: string) {
    if (!term) {
      this.patologies = [];
      return of([]);
    }

    const gender = this.prescriptionForm.get('gender')?.value;
    const ageYears = this.getAgeYearsForBackend();

    return this.catalogsService.getPatologiessByName(term, ageYears, gender).pipe(
      map((res: DefaultResponse<Patology[]>) => {
        const data = (res.data ?? []).map(pathology => ({
          ...pathology,
          type: 3
        }));
        this.patologies = data;
        return data;
      }),
      catchError(() => {
        this.patologies = [];
        return of([]);
      })
    );
  }

  /** Devuelve EDAD en AÑOS (entero) para el backend.
   *  Prioridad:
   *   1) dateOfBirth (lo correcto)
   *   2) fallback: intenta parsear el texto de "age" (por si dateOfBirth viene vacio)
   */
  private getAgeYearsForBackend(): number {
    const dobIso = this.prescriptionForm.get('dateOfBirth')?.value;

    // 1) DOB => años exactos
    const yearsFromDob = this.extractYearsFromDob(dobIso);
    if (yearsFromDob !== null) return yearsFromDob;

    // 2) Fallback por si no hay DOB: parsear "age" (texto)
    const ageText = (this.prescriptionForm.get('age')?.value ?? '').toString();
    return this.extractYearsFromAgeText(ageText);
  }

  private extractYearsFromDob(dobIso: any): number | null {
    if (!dobIso) return null;

    const dob = new Date(dobIso);
    if (isNaN(dob.getTime())) return null;

    // Usa tu metodo existente (años/meses/dias exactos)
    const { years } = this.calculateExactAge(dob);
    return Number.isFinite(years) ? Math.max(0, Math.trunc(years)) : 0;
  }

  /** Lee "1 AÑO 5 MESES", "2 AÑOS", "20 DIAS", etc. y devuelve solo AÑOS */
  private extractYearsFromAgeText(text: string): number {
    const t = (text ?? '').toUpperCase();

    // Busca "X AÑO" o "X AÑOS"
    const match = t.match(/(\d+)\s*AÑOS?/);
    if (match?.[1]) return Math.max(0, parseInt(match[1], 10));

    // Si no dice años (ej: "5 MESES" o "20 DIAS"), para backend mandamos 0
    return 0;
  }


  searchMedicamentsByName(term: string) {
    if (!term) {
      this.medicaments = [];
      return of([]);
    }

    return this.catalogsService.getMedicamentsByName(term).pipe(
      map((res: DefaultResponse<Medicament[]>) => {
        const data = [...(res.data ?? [])];
        this.medicaments = data;
        return data;
      }),
      catchError(() => {
        this.medicaments = [];
        return of([]);
      })
    );
  }

  searchPatientByName(term: string) {
    if (!term) {
      this.patients = [];
      return of([]);
    }

    return this.catalogsService.getPatientsByName(term).pipe(
      map((res: DefaultResponse<PatientDetails[]>) => {
        const data = [...(res.data ?? [])];
        this.patients = data;
        return data;
      }),
      catchError(() => {
        this.patients = [];
        return of([]);
      })
    );
  }

  updateDependentFields(gender: string): void {
    if (gender === 'M') {
      this.isGenderRestricted = true;
      this.prescriptionForm.get('weeksOfAmenorrhea')?.reset();
      this.prescriptionForm.get('pregnancy')?.reset();
      this.prescriptionForm.get('breastFeeding')?.reset();

      this.prescriptionForm.get('weeksOfAmenorrhea')?.disable();
      this.prescriptionForm.get('pregnancy')?.disable();
      this.prescriptionForm.get('breastFeeding')?.disable();
    } else {
      this.isGenderRestricted = false;
      this.prescriptionForm.get('weeksOfAmenorrhea')?.enable();
      this.prescriptionForm.get('pregnancy')?.enable();
      this.prescriptionForm.get('breastFeeding')?.enable();
    }
  }

  onGenderChange(gender: string): void {
    this.updateDependentFields(gender);
  }

  handlePregnancyChange(isPregnant: boolean): void {
    this.isPregnant = isPregnant;
    const weeksControl = this.prescriptionForm.get('weeksOfAmenorrhea');

    if (isPregnant) {
      weeksControl?.setValue(1);
      weeksControl?.enable();
    } else {
      weeksControl?.setValue(null);
      if (this.isGenderRestricted) {
        weeksControl?.disable();
      }
    }
  }

  addNewLine(value: Medicament): void {
    const isParafarmacia = (value.idType === 'PARAFARMACIA');

    const newLine: any = new PrescriptionLine({
      drugType: value.idType,
      drug: isParafarmacia ? '0' : String(value.id ?? ''),
      dose: null,
      unitId: null,
      duration: null,
      durationType: '',
      route: null,
      indication: 0,
      name: value.nombre,
      summary: value.summary,
      indicationName: '',
      frecuency: null,
      frecuencyType: '',
      idFrecuencyType: null,
      obs: '',
      unitIdName: '',
      durationName: '',
      routeName: '',
      hide: false,
      showNoAnalysisLegend: isParafarmacia
    });

    const cleanData = this.gfs.mayusAcentos(newLine);
    const index = this.prescriptionService.addPrescriptionLine(cleanData);
    this.updateLine(cleanData, index);
    this.prescriptionForm.patchValue({ 'searchMedicaments': '' });
    this.medicaments = [];
    this.resetAutoAlerts();
  }

  addNewPatientLine(value: any): void {
    let {type, name, id, code} = this.generateNewLine(value);

    const newLine: PatientLine = new PatientLine({
      detailType: type,
      detailTypeName: name,
      cronical: false,
      detailTypeId: id,
      type: value.type,
      detailTypeCode: code,
    });

    this.patientService.addPatientLine(newLine);
  }

  updateLine(toUpdate: PrescriptionLine, index: number): void {
    const { drug, drugType, name, summary } = toUpdate;

    this.prescriptionService.getRelations(drug, drugType).subscribe({
      next: (data) => {
        this.gfs.mayusAcentos(data);

        const routes = Array.isArray(data?.routes) ? data.routes : [];
        const units  = Array.isArray(data?.units) ? data.units : [];
        const indications = Array.isArray(data?.indications) ? data.indications : [];

        (toUpdate as any).requiresUnit = units.length > 0;
        (toUpdate as any).requiresRoute = routes.length > 0;
        (toUpdate as any).requiresIndication = indications.length > 0;

        const dialogRef = this.dialog.open(PrescriptionLineComponent, {
          maxWidth: 'none',
          data: {
            frecuencyTypes: this.frecuencyTypes,
            routes,
            units,
            indications,
            name,
            summary,
            toUpdate,
          },
        });

        dialogRef.afterClosed().subscribe(async (result) => {
          if (!result) return;

          const isParafarmacia = this.isParafarmaciaRow(toUpdate);

          toUpdate.dose = result.dose;

          if ((toUpdate as any).requiresUnit) {
            toUpdate.unitId = Number(result.unitId ?? 0);
          } else {
            toUpdate.unitId = 0;
            toUpdate.unitIdName = '';
          }

          toUpdate.duration = result.duration;
          toUpdate.durationType = result.durationType;
          toUpdate.route = result.route;
          toUpdate.indication = Number(result.indication ?? 0);
          toUpdate.indicationName = result.indicationName ?? '';
          toUpdate.frecuency = result.frecuency;
          toUpdate.frecuencyType = result.frecuencyType;
          toUpdate.idFrecuencyType = result.idFrecuencyType;
          toUpdate.obs = result.obs;
          toUpdate.durationName = result.durationName;
          toUpdate.routeName = result.routeName;

          // ✅ ESTA ES LA CLAVE
          (toUpdate as any).showNoAnalysisLegend = isParafarmacia;

          const cleanData: any = this.gfs.mayusAcentos(toUpdate);
          cleanData.showNoAnalysisLegend = isParafarmacia;

          await this.prescriptionService.updatePrescriptionLine(index, cleanData);
          this.prescriptionService.dataChange.next([...this.prescriptionService.data]);

          await this.confirmAdd();
        });
      },
    });

    this.resetAutoAlerts();
  }

  deleteLine(index: number, row?: PrescriptionLine): void {
    // Obten la linea real
    const line = row ?? this.prescriptionService.data[index];

    // Si es PRODUCT, elimina su ID por VALOR (no por indice)
    if (line && String(line.drug) !== '0') {
      const idStr = String(line.drug);
      if (Array.isArray(this.prescription.medicamentos)) {
        this.prescription.medicamentos = this.prescription.medicamentos.filter((id) => id !== idStr);
      }
      // limpia tambien el array de nombres si lo usas para mostrar
      this.medicamentNames = this.medicamentNames.filter((n) => n !== (line.name ?? '') && n !== (line.summary ?? ''));
    }

    // Elimina de la fuente de datos de la tabla
    this.prescriptionService.deletePrescriptionLine(index);

    // Recalcula alertas
    this.checkAlertsControl();
    if (this.prescriptionService.data.length > 0) {
      this.confirmAdd().then();
    } else {
      this.alertasControl = 0;
      this.alertas = [];
    }

    // Opcional: limpia el input para evitar que quede “seleccionado”
    this.prescriptionForm.patchValue({ searchMedicaments: '' });
    this.medicaments = [];
    this.resetAutoAlerts();
  }


  deletePatientLine(index: number): void {
    this.patientService.deletePatientLine(index);
    this.history.splice(index, 1);
  }

  calculatePeriodEndDate(duration: number, durationType: string): string {
    const today = new Date();
    let resultDate = new Date(today);

    switch (durationType) {
      case 'YEAR':
        resultDate.setFullYear(today.getFullYear() + duration);
        break;
      case 'MONTH':
        resultDate.setMonth(today.getMonth() + duration);
        break;
      case 'WEEK':
        resultDate.setDate(today.getDate() + duration * 7);
        break;
      case 'DAY':
        resultDate.setDate(today.getDate() + duration);
        break;
      case 'HOUR':
        resultDate.setHours(today.getHours() + duration);
        break;
      case 'MINUTE':
        resultDate.setMinutes(today.getMinutes() + duration);
        break;
    }

    return resultDate.toISOString();
  }

  public async confirmAdd(step = 2) {
    if (!this.validateBeforeAnalysis()) {
      return;
    }

    // 1) Extraer detalles para analytics (moleculas/alergias/patologias)
    const { patologias, alergias, moleculas } = this.getdetailsAnalytics();

    // 2) Datos del form del paciente
    const prescription = this.prescriptionForm.getRawValue();
    prescription.pregnancy = !!prescription.pregnancy;

    // 3) Tomar TODAS las lineas capturadas
    const allLines = this.prescriptionDataSource.getValue() ?? [];

    // 4) Filtrar SOLO las analizables (drug != '0')
    const analysableSrc = allLines.filter(l => String(l.drug ?? '').trim() !== '0');

    // 5) Si NO hay analizables, no llamamos al backend de analisis
    if (analysableSrc.length === 0) {
      this.medicamentoActivo = [];
      this.alertas = [];
      this.alertasControl = 0;

      return; // 🚫 detener aqui
    }

    // 6) Mapear SOLO las lineas analizables
    const prescriptionLines = analysableSrc.map(line => ({
      drugType: line.drugType,
      drug: line.drug,
      dose: line.dose,
      unitId: line.unitId ? line.unitId : 0,
      frecuency: line.frecuency,
      frecuencyType: line.frecuencyType,
      idFrecuencyType: line.idFrecuencyType,
      duration: line.duration,
      durationType: line.durationType,
      route: line.route ? line.route : 0,
      indication: String(Number(line.indication ?? 0))
    }));

    // 7) Armar payload
    const fullPrescription = {
      patient: {
        idPaciente: this.patient.idPaciente,
        gender: prescription.gender,
        dateOfBirth: prescription.dateOfBirth,
        weight: Number(prescription.weight ?? 0),
        height: Number(prescription.height ?? 0),
        breastFeeding: prescription.breastFeeding,
        weeksOfAmenorrhea: prescription.weeksOfAmenorrhea,
        pregnancy: prescription.pregnancy,
        creatin: prescription.creatin || 120,
        molecules: moleculas,
        allergies: alergias,
        pathologies: patologias,
      },
      prescriptionLines,
      medicamentoActivo: this.medicamentoActivo ?? []
    };

    const cleanData = this.gfs.mayusAcentos(fullPrescription);

    // 8) Enviar segun step
    switch (step) {
      case 1: {
        this.prescriptionService.postToAnalytics(cleanData);
        if (!this.havePosted) this.havePosted = true;
        this.openHtmlModal(this.htmlContent);
        break;
      }
      case 2: {
        this.prescriptionService.postToAnalyticsXML(cleanData).subscribe({
          next: (data: any) => {
            let xmlData: string;

            if (typeof data.data === 'string') {
              xmlData = decryptData(data.data, environment.encryptionKey);
            } else if (data.data && typeof data.data.xmlResponse === 'string') {
              xmlData = data.data.xmlResponse;
            } else {
              xmlData = '';
            }

            this.medicamentoActivo = data.data?.medicamentoActivo ?? [];

            if (!this.havePosted) this.havePosted = true;

            this.alertasControl = 0;
            this.alertas = this.processXmlWithParser(xmlData);
            this.checkAlertsControl();

            if (this.alertasControl > 0 && !this.autoAlertsOpened) {
              this.autoAlertsOpened = true;
              this.openPrescriptionLineModal();
            }
          },
          error: (err) => {
          }
        });
        break;
      }
    }
  }

  processXmlWithParser(xmlString: string) {
    const parser = new XMLParser({
      ignoreAttributes: false,
      attributeNamePrefix: "",
    });

    const jsonObj = parser.parse(xmlString);
    const data = jsonObj.feed.entry;
    if (!data) return [];

    const prescriptionLines = data.filter((entry: any) => entry.category?.term === "PRESCRIPTION_LINE");
    const alerts = data.filter((entry: any) => entry.category?.term === "ALERT");

    const parsedLines = prescriptionLines.map((line: any) => {
      const id = line.id;
      const drugId = line["vidal:drugId"];

      const severities = Object.entries(line)
        .filter(([key, value]: any) => key.startsWith("vidal:max") && value.severity !== "NO_ALERT")
        .map(([key, value]: [string, any]) => ({
          type: key,
          severity: value.severity,
          description: value["#text"],
        }));

      // Obtener alertas de tipo NO duplicidad ni redundancia ingrediente activo
      const rawAlerts = alerts
        .filter((alert: any) =>
          alert["vidal:severity"] === "LEVEL_4" &&
          alert.link?.href === id &&
          alert["vidal:alertType"]?.name !== "SAME_DRUG" &&
          alert["vidal:alertType"]?.name !== "REDUNDANT_ACTIVE_INGREDIENT"
        )
        .map((alert: any) => ({
          title: alert.title?.split(":")[0]?.trim() || '',
          severity: alert["vidal:severity"],
          description: this.normalizeHtmlEntities(alert.content?.["#text"] || alert["vidal:detail"]?.["#text"]),
          type: alert["vidal:alertType"]?.["#text"],
          subType: alert["vidal:subType"]?.["#text"],
          detail: alert["vidal:detail"]?.["#text"],
          medicamento: alert.title?.split(":")[1]?.trim() || ''
        }));

      // Eliminar duplicados por combinacion tipo + medicamento
      const seen = new Set<string>();
      const relatedAlerts = rawAlerts.filter((alert: any) => {
        const key = `${alert.title}-${alert.medicamento}`;
        if (seen.has(key)) return false;
        seen.add(key);
        return true;
      });

      return {
        id,
        drugId,
        title: line.title,
        severities,
        alerts: relatedAlerts,
      };
    });

    // --- Duplicidades medicamentosas (SAME_DRUG) SOLO UNA POR MEDICAMENTO ---
    const globalDuplicatedAlerts: any[] = [];
    const seenDuplicados = new Set<string>();
    alerts
      .filter((alert: any) =>
        alert["vidal:alertType"]?.name === "SAME_DRUG" &&
        alert["vidal:severity"] === "LEVEL_4"
      )
      .forEach((alert: any) => {
        const drugName = alert.title?.split(":")[1]?.trim() || "Medicamento no identificado";
        if (seenDuplicados.has(drugName.toUpperCase())) return; // Ya lo pusimos
        seenDuplicados.add(drugName.toUpperCase());

        globalDuplicatedAlerts.push({
          title: "Duplicidades medicamentosas",
          alerts: [{
            title: 'Duplicidad',
            severity: alert["vidal:severity"],
            description: this.normalizeHtmlEntities(alert.content?.["#text"] || alert["vidal:detail"]?.["#text"]),
            medicamento: drugName
          }]
        });
      });

    // --- Ingredientes activos redundantes (REDUNDANT_ACTIVE_INGREDIENT), UN SOLO RENGLON CON TODOS LOS MEDS ---
    const redundantIngredientAlerts: any[] = [];
    alerts
      .filter((alert: any) =>
        alert["vidal:alertType"]?.name === "REDUNDANT_ACTIVE_INGREDIENT" &&
        alert["vidal:severity"] === "LEVEL_4"
      )
      .forEach((alert: any) => {
        // Intenta extraer los medicamentos listados en el detail/content
        const detail: string = alert.detail || alert.content?.["#text"] || alert["vidal:detail"]?.["#text"] || '';
        const medicamentos: string[] = [];
        detail.split('\n').forEach((line: string) => {
          const match = line.match(/-\s*([^\(]+)\s*\((.*?)\)/); // Ej: - PARACETAMOL BIOMEP 500 mg Tab. (paracetamol)
          if (match) {
            medicamentos.push(match[1].trim());
          }
        });
        if (medicamentos.length === 0) {
          medicamentos.push(alert.title?.split(":")[1]?.trim() || "Medicamento no identificado");
        }
        // Unir medicamentos con ' +\n' para mostrar en la misma celda con saltos de linea
        const medicamentoCell = medicamentos.join(' +<br>');
        redundantIngredientAlerts.push({
          title: "Redundancia de ingrediente activo",
          alerts: [{
            title: "Redundancia de ingrediente activo",
            severity: alert["vidal:severity"],
            description: this.normalizeHtmlEntities(detail),
            medicamento: medicamentoCell
          }]
        });
      });

    return [...parsedLines, ...globalDuplicatedAlerts, ...redundantIngredientAlerts];
  }

  onEnterMedicaments(event: KeyboardEvent | Event): void {
    // ambos tienen preventDefault
    event.preventDefault();
    this.addFreeMedicament();
  }


  addFreeMedicament() {
    if (!this.canUseMedicationSearch) {
      return;
    }

    // 2) Tomar el texto escrito en el buscador
    const termRaw = this.prescriptionForm.get('searchMedicaments')?.value;
    const term = (termRaw ?? '').toString().trim();
    if (!term) {
      Swal.fire('AVISO', 'Escribe el nombre del medicamento para agregarlo.', 'info').then();
      return;
    }

    // 3) Evitar duplicar: mismo nombre y tipo PARAFARMACIA (drug = '0')
    const exists = this.prescriptionService.data.some(l =>
      String(l.drug) === '0' &&
      l.drugType === 'PARAFARMACIA' &&
      (l.name ?? '').trim().toUpperCase() === term.toUpperCase()
    );
    if (exists) {
      Swal.fire('AVISO', 'Ese medicamento ya se agrego.', 'info').then();
      this.prescriptionForm.patchValue({ searchMedicaments: '' });
      return;
    }

    // 4) Construir objeto "custom" y abrir posologia
    const customMed: any = {
      id: 0,
      idType: 'PARAFARMACIA',
      nombre: '',
      summary: term
    };

    this.addNewLine(customMed);          // agrega la linea
    this.prescriptionForm.patchValue({   // limpia el input
      searchMedicaments: ''
    });
    this.medicaments = [];               // limpia sugerencias
  }


  public async crearReceta(): Promise<void> {
    if (this.isEditMode) {
      await this.actualizarReceta();
      return;
    }

    if (!this.isGloballyValid && !this.hasTriedSave) {
      this.hasTriedSave = true;
      this.canSave();
      return;
    }

    if (!this.isGloballyValid) {
      return;
    }

    const { patologias, alergias, moleculas } = this.createExtracted();
    const { patologiasCronicas, alergiasCronicas, moleculasCronicas } = this.cronicalExtracted();

    const today = new Date().toISOString();
    const prescription = this.prescriptionForm.getRawValue();
    prescription.pregnancy = !!prescription.pregnancy;
    prescription.breastFeeding = prescription.breastFeeding == 'ALL';

    // Todas las lineas capturadas en la tabla
    const allLines = this.prescriptionDataSource.getValue() ?? [];

    // 1) Lineas normales (drug != '0')
    const prescriptionLines = allLines
      .filter(line => String(line.drug ?? '').trim() !== '0')
      .map(line => ({
        idMedicamento: Number(line.drug) || 0,
        tipoMedicamento: line.drugType,
        unidadDispensacionId: line.unitId ? line.unitId : 0,
        rutaAdministracionId: line.route ?? 0,
        indicacion: String(Number(line.indication ?? 0)),
        indicacionNombre: line.indicationName ?? '',
        frecuency: line.frecuency ?? 0,
        idFrecuencyType: line.idFrecuencyType ?? 0,
        frecuencyType: line.frecuencyType ?? '',
        observaciones: line.obs ?? '',
        cantidadDiaria: line.dose ?? 0,
        duracion: line.duration ?? 0,
        unidadDuracion: line.durationType ?? '',
        periodoInicio: today,
        periodoTerminacion: this.calculatePeriodEndDate(line.duration ?? 0, line.durationType ?? 'DAY'),
        hide: Boolean(line.hide ?? false),
      }));

    // 2) Lineas de PARAFARMACIA (drug == '0' o tipo PARAFARMACIA)
    const paraFarmaciaLine = allLines
      .filter(line => String(line.drug ?? '').trim() === '0' || line.drugType === 'PARAFARMACIA')
      .map(line => ({
        idDetalleReceta: null,
        idMedicamento: 0,
        tipoMedicamento: 'PARAFARMACIA',
        descripcionParaFarmacia: line.summary ?? '',
        cantidadDiaria: line.dose ?? 0,
        unidadDispensacionId: line.unitId ?? 0,
        rutaAdministracionId: line.route ?? 0,
        indicacion: '',
        duracion: line.duration ?? 0,
        unidadDuracion: line.durationType ?? '',
        periodoInicio: today,
        periodoTerminacion: this.calculatePeriodEndDate(line.duration ?? 0, line.durationType ?? 'DAY'),
        fechaSurtido: null,
        indicacionNombre: '',
        frecuency: line.frecuency ?? 0,
        idFrecuencyType: line.idFrecuencyType ?? 0,
        observaciones: line.obs ?? '',
        hide: Boolean(line.hide ?? false),
      }));

    // 3) Armar payload final
    const fullPrescription: any = {
      idMedico: null,
      idPaciente: this.patient.idPaciente,
      paciente: {
        peso: Number(prescription.weight ?? 0),
        talla: Number(prescription.height ?? 0),
        embarazo: prescription.pregnancy,
        semanasAmenorrea: prescription.weeksOfAmenorrhea ?? 0,
        lactancia: prescription.breastFeeding,
        creatinina: prescription.creatin || 120,
        moleculas,
        alergias,
        patologias
      },
      prescriptionLines,
      paraFarmaciaLine,
      patologiasCronicas,
      alergiasCronicas,
      moleculasCronicas,
      folio: ''
    };

    const cleanData = this.gfs.mayusAcentos(fullPrescription);

    this.prescriptionService.postToPrescription(cleanData).subscribe({
      next: () => {
        Swal.fire('EXITO', 'RECETA CREADA CON EXITO', 'success').then(() => {
          this.router.navigate(['prescription/prescription-list']).then();
        });
      },
      error: (err) => {
        this.httpMsgHandler.handleMsg(err);
      }
    });
  }

  public isParafarmaciaRow(row: any): boolean {
    if (!row) return false;

    const drugType = (row.drugType ?? row.tipoMedicamento ?? row.medicamentoType ?? '').toString().toUpperCase();
    const drug     = (row.drug ?? row.idMedicamento ?? row.medicamentoId ?? '').toString().trim();

    return drugType === 'PARAFARMACIA' || drug === '0' || Number(drug) === 0;
  }

  public shouldShowParafarmaciaLegend(row: any): boolean {
    return this.isParafarmaciaRow(row) && row?.showNoAnalysisLegend === true;
  }

  openPrescriptionLineModal(): void {
    const dialogRef = this.dialog.open(AlertsListComponent, {
      maxWidth: 'none',
      data: {
        alerts: this.alertas,
      },
    });

    dialogRef.afterClosed().subscribe(() => {
    });
  }

  normalizeHtmlEntities(input: string): string {
    const parser = new DOMParser();
    return parser.parseFromString(`<!doctype html><body>${input}`, 'text/html').body.textContent || '';
  }

  onBreastFeedingChange(event: MatCheckboxChange): void {
    const value = event.checked ? 'ALL' : 'NONE';
    this.prescriptionForm.get('breastFeeding')?.setValue(value);
  }

  ngAfterViewInit(): void {
    if (!this.isEditMode && this.recibido && (this.recibido as any).idPaciente) {
      this.setSelectedPatient(this.recibido, 1);
      this.cd.detectChanges();
    }
  }

  openMedicamentoDocuments(row: any) {
    // Aqui ajusta segun los campos reales de tu objeto "row" (de la tabla de medicamentos)
    const medicamentoId = row.drug || row.idMedicamento; // o el campo que uses para el ID
    const medicamentoType = row.drugType || row.tipoMedicamento; // o el campo que uses para el tipo

    this.dialog.open(MedicamentoDocumentsModalComponent, {
      data: {medicamentoId, medicamentoType},
      width: '700px',         // o prueba con '700px', '50vw', etc.
      maxWidth: '100vw',
      height: '52vh',       // O '600px', segun te guste
      maxHeight: '95vh'
    });
  }

  private checkAlertsControl() {
    this.alertasControl = 0;
    if (this.alertas) {
      this.alertas.forEach((alerta: any) => {
        this.alertasControl += alerta.alerts.length;
      })
    } else {
      this.alertasControl = 0;
    }

  }

  private generateNewLine(value: any) {
    let type = '';
    let name = '';
    let id = 0;
    let code = '';

    switch (value.type) {
      case 1:
        type = 'Alergia';
        name = value.nameAllergy;
        id = value.idAllergy;
        break;
      case 2:
        type = 'Molecula';
        name = value.nameMolecule;
        id = value.idMolecule;
        break;
      case 3:
        type = 'Patologia';
        name = value.nameCIM10;
        id = value.idCIM10;
        code = value.code
        break;
    }
    return {type, name, id, code};
  }

  private cronicalExtracted() {
    let patologiasCronicas: number[] = [];
    let alergiasCronicas: number[] = [];
    let moleculasCronicas: number[] = [];

    this.selection.selected.forEach(value => {
      switch (value.type) {
        case 1:
          alergiasCronicas.push(value.detailTypeId)
          break;
        case 2:
          moleculasCronicas.push(value.detailTypeId)
          break;
        case 3:
          patologiasCronicas.push(value.detailTypeId)
          break;
      }
    });
    this.processDataSourceIds(this.patientHistoryDataSource, alergiasCronicas, moleculasCronicas, patologiasCronicas);

    return {patologiasCronicas, alergiasCronicas, moleculasCronicas};
  }

  private getdetailsAnalytics() {
    let patologias: (string | undefined)[] = [];
    let alergias: string[] = [];
    let moleculas: string[] = [];

    this.processDataSourceAnalytics(this.patientDataSource, alergias, moleculas, patologias);
    this.processDataSourceAnalytics(this.patientHistoryDataSource, alergias, moleculas, patologias);

    return {patologias, alergias, moleculas};
  }

  private processDataSourceAnalytics(
    dataSource: BehaviorSubject<PatientLine[]>,
    alergias: string[],
    moleculas: string[],
    patologias: (string | undefined)[]) {

    dataSource.getValue().forEach(value => {
      switch (value.type) {
        case 1:
          if (!alergias.includes(String(value.detailTypeId))) {
            alergias.push(String(value.detailTypeId));
          }
          break;
        case 2:
          if (!moleculas.includes(String(value.detailTypeId))) {
            moleculas.push(String(value.detailTypeId));
          }
          break;
        case 3:
          if (!patologias.includes(value.detailTypeCode)) {
            patologias.push(value.detailTypeCode);
          }
          break;
      }
    });
  }

  private createExtracted() {
    let patologias: number[] = [];
    let alergias: number[] = [];
    let moleculas: number[] = [];

    this.processDataSourceIds(this.patientDataSource, alergias, moleculas, patologias);

    return {patologias, alergias, moleculas};
  }

  private processDataSourceIds(
    dataSource: BehaviorSubject<PatientLine[]>,
    alergias: number[],
    moleculas: number[],
    patologias: number[]) {

    dataSource.getValue().forEach(value => {
      switch (value.type) {
        case 1:
          if (!alergias.includes(value.detailTypeId)) {
            alergias.push(value.detailTypeId);
          }
          break;
        case 2:
          if (!moleculas.includes(value.detailTypeId)) {
            moleculas.push(value.detailTypeId);
          }
          break;
        case 3:
          if (!patologias.includes(value.detailTypeId)) {
            patologias.push(value.detailTypeId);
          }
          break;
      }
    });
  }

  private isValidSearchTerm(term: string): boolean {
    return term?.length >= 4;
  }

  /** Trae antecedentes cronicos del paciente desde /api/Pacientes
   *  Soporta respuesta: objeto | {data:obj} | arreglo | {data:arreglo}
   *  Devuelve { alergias:[{id,name}], molecules:[{id,name}], patologias:[{id,name,code}] }
   */
  private fetchAntecedentesCronicos(idPaciente?: string, idUsuario?: string) {
    const params: any = {};
    if (idPaciente) params['IdPaciente'] = idPaciente;
    if (idUsuario)  params['IdUsuario']  = idUsuario;

    return this.http.get<any>(`${environment.backend_url}Pacientes`, { params }).pipe(
      map((resp: any) => {
        const raw = typeof resp === 'string' ? JSON.parse(resp) : resp;

        // Normalizar a arreglo de pacientes
        const data = raw?.data ?? raw;
        const arr  = Array.isArray(data) ? data : (data ? [data] : []);
        const pac  = arr.find(p =>
          (p?.idPaciente ?? p?.IdPaciente ?? '').toLowerCase() === (idPaciente ?? '').toLowerCase()
        ) ?? arr[0] ?? {};

        // ✅ Bandera propia del paciente (si true => tiene PIN activo => NO se puede ocultar)
        const pinActivo = Boolean(pac?.pinActivo ?? false);

        const alergiasSrc   = Array.isArray(pac?.alergias)   ? pac.alergias   : [];
        const moleculesSrc  = Array.isArray(pac?.molecules)  ? pac.molecules  : [];
        const patologiasSrc = Array.isArray(pac?.patologias) ? pac.patologias : [];

        const alergias = alergiasSrc.map((a: any) => ({
          id:   a?.idAllergy ?? a?.id ?? a,
          name: a?.nameAllergy ?? a?.name ?? `ALERGIA #${a?.idAllergy ?? a?.id ?? a}`
        }));

        const molecules = moleculesSrc.map((m: any) => ({
          id:   m?.idMolecule ?? m?.id ?? m,
          name: m?.nameMolecule ?? m?.name ?? `MOLECULA #${m?.idMolecule ?? m?.id ?? m}`
        }));

        const patologias = patologiasSrc.map((p: any) => ({
          id:   p?.idCIM10 ?? p?.id ?? 0,
          name: p?.nameCIM10 ?? p?.name ?? '',
          code: p?.code ?? ''
        }));

        // ✅ ahora regresamos también pinActivo
        return { alergias, molecules, patologias, pinActivo };
      })
    );
  }

  /** Sincroniza antecedentes cronicos con UI:
   *  - Marca "cronico" en Diagnostico si coincide (patientService.data).
   *  - Inserta/actualiza en ANTECEDENTES (patientHistoryService.data) con cronical=true.
   *  - Mantiene los arrays de ids para el payload.
   */
  private syncCronicosConUI(ant: { alergias:any[]; molecules:any[]; patologias:any[]; pinActivo: boolean }) {
    // 1) Guardar ids para payload
    this.canHideMedication = Boolean(ant?.pinActivo);
    this.alergiasCronicas   = ant.alergias.map(a  => Number(a.id)).filter(n => !isNaN(n));
    this.moleculesCronicas  = ant.molecules.map(m => Number(m.id)).filter(n => !isNaN(n));
    this.patologiasCronicas = ant.patologias.map(p => Number(p.id)).filter(n => !isNaN(n));

    // 2) Marcar "cronico" en DIAGNOSTICO (tabla lateral)
    const markCronical = (ids: number[], type: 1|2|3) => {
      const rows = this.patientService.data; // getter → array actual
      rows.forEach((r: any) => {
        if (r?.type === type) {
          const id = Number(r?.detailTypeId);
          if (!isNaN(id)) r.cronical = ids.includes(id);
        }
      });
      // Notificar cambios a la tabla
      this.patientService.dataChange.next([...rows]);
    };

    markCronical(this.alergiasCronicas,   1);
    markCronical(this.moleculesCronicas,  2);
    markCronical(this.patologiasCronicas, 3);

    // 3) Poblar/actualizar la tabla de ANTECEDENTES con cronical=true
    const antecedentes = this.patientHistoryService.data; // array actual

    const upsertAntecedente = (
      detailType: 'Alergia'|'Molecula'|'Patologia',
      type: 1|2|3,
      id: number,
      name: string,
      code = ''
    ) => {
      const idx = antecedentes.findIndex(l =>
        Number(l.detailTypeId) === Number(id) &&
        Number(l.type) === Number(type)
      );

      if (idx === -1) {
        // No existe → agregar
        this.patientHistoryService.addPatientLine(new PatientLine({
          detailType,
          detailTypeName: name,
          cronical: true,
          detailTypeId: id,
          type,
          detailTypeCode: code
        }));
      } else {
        // Existe → marcar como cronico y notificar
        antecedentes[idx].cronical = true;
        this.patientHistoryService.dataChange.next([...antecedentes]);
      }
    };

    ant.alergias.forEach(a  => upsertAntecedente('Alergia',  1, Number(a.id), a.name));
    ant.molecules.forEach(m => upsertAntecedente('Molecula', 2, Number(m.id), m.name));
    ant.patologias.forEach(p => upsertAntecedente('Patologia',3, Number(p.id), p.name, p.code ?? ''));
  }

  /** Genera una llave consistente por fila para comparar: tipo + id (y code para patologias si aplica) */
  private keyFromLine(l: PatientLine): string {
    const t = l?.type ?? 0; // 1=Alergia, 2=Molecula, 3=Patologia
    const id = String(l?.detailTypeId ?? '');
    // Para patologias, agrega code si viene (cuando id no es confiable)
    const code = (t === 3 && l?.detailTypeCode) ? `|${l.detailTypeCode}` : '';
    return `${t}:${id}${code}`;
  }

  private refreshAgeDisplayFromDob(dobIso: string | null | undefined): void {
    if (!dobIso) {
      this.prescriptionForm.patchValue({ age: '' }, { emitEvent: false });
      return;
    }

    const dob = new Date(dobIso);
    if (isNaN(dob.getTime())) {
      this.prescriptionForm.patchValue({ age: '' }, { emitEvent: false });
      return;
    }

    const { years, months, days } = this.calculateExactAge(dob);
    const text = this.buildAgeHumanReadable(years, months, days);

    this.prescriptionForm.patchValue({ age: text }, { emitEvent: false });
  }

  /** Calcula edad exacta años/meses/dias con calendario */
  private calculateExactAge(dob: Date): { years: number; months: number; days: number } {
    const today = new Date();

    let years = today.getFullYear() - dob.getFullYear();
    let months = today.getMonth() - dob.getMonth();
    let days = today.getDate() - dob.getDate();

    if (days < 0) {
      const prevMonthDays = new Date(today.getFullYear(), today.getMonth(), 0).getDate();
      days += prevMonthDays;
      months--;
    }

    if (months < 0) {
      months += 12;
      years--;
    }

    if (years < 0) years = 0;
    if (months < 0) months = 0;
    if (days < 0) days = 0;

    return { years, months, days };
  }

  private buildAgeHumanReadable(years: number, months: number, days: number): string {
    // < 1 mes => dias
    if (years === 0 && months === 0) {
      const d = Math.max(days, 0);
      return `${d} ${d === 1 ? 'DIA' : 'DIAS'}`;
    }

    // < 1 año => meses (puedes incluir dias si quieres)
    if (years === 0) {
      const m = Math.max(months, 0);
      return `${m} ${m === 1 ? 'MES' : 'MESES'}`;
    }

    // >= 1 año => años (y meses si hay)
    if (months > 0) {
      return `${years} ${years === 1 ? 'AÑO' : 'AÑOS'} ${months} ${months === 1 ? 'MES' : 'MESES'}`;
    }

    return `${years} ${years === 1 ? 'AÑO' : 'AÑOS'}`;
  }


  openPriscaNormal(): void {
    if (!this.validateBeforeAnalysis()) {
      return;
    }

    const { patologias, alergias, moleculas } = this.getdetailsAnalytics();
    const prescription = this.prescriptionForm.getRawValue();
    prescription.pregnancy = !!prescription.pregnancy;

    const allLines = this.prescriptionDataSource.getValue() ?? [];
    const analysableSrc = allLines.filter(l => String(l.drug ?? '').trim() !== '0');

    if (!this.patient?.idPaciente) {
      Swal.fire('AVISO', 'PRIMERO SELECCIONA UN PACIENTE.', 'info').then();
      return;
    }

    if (analysableSrc.length === 0) {
      Swal.fire('AVISO', 'AGREGA AL MENOS UN MEDICAMENTO PARA PRISCA.', 'info').then();
      return;
    }

    const prescriptionLines = analysableSrc.map(line => ({
      drugType: line.drugType,
      drug: line.drug,
      dose: line.dose,
      unitId: line.unitId ? line.unitId : 0,
      frecuency: line.frecuency,
      frecuencyType: line.frecuencyType,
      idFrecuencyType: line.idFrecuencyType,
      duration: line.duration,
      durationType: line.durationType,
      route: line.route ? line.route : 0,
      indication: String(Number(line.indication ?? 0)),
    }));

    const payload = {
      patient: {
        idPaciente: this.patient.idPaciente,
        gender: prescription.gender,
        dateOfBirth: prescription.dateOfBirth,
        weight: Number(prescription.weight ?? 0),
        height: Number(prescription.height ?? 0),
        breastFeeding: prescription.breastFeeding,
        weeksOfAmenorrhea: prescription.weeksOfAmenorrhea,
        pregnancy: prescription.pregnancy,
        creatin: prescription.creatin || 120,
        molecules: moleculas,
        allergies: alergias,
        pathologies: patologias,
      },
      prescriptionLines,
      medicamentoActivo: this.medicamentoActivo ?? [],
    };

    const clean = this.gfs.mayusAcentos(payload);
    const url = `${environment.backend_url}Consulta/AnalisisPrisca`;

    // ✅ IMPORTANTE: si el backend responde HTML puro, pídeselo como TEXTO
    this.http.post(url, clean, {
      headers: { 'Content-Type': 'application/json', 'Accept': 'text/html' },
      responseType: 'text', // 👈 aquí está la clave
    }).subscribe({
      next: (html: string) => {
        if (!html || !html.trim()) {
          Swal.fire('AVISO', 'NO SE RECIBIO HTML DE PRISCA.', 'info').then();
          return;
        }

        // (Opcional) Validación rápida: que parezca HTML
        const looksLikeHtml =
          html.includes('<html') || html.includes('<!DOCTYPE html') || html.includes('<head');

        // ✅ Aquí ya NO hay JSON.parse, NO hay raw.data, es HTML directo
        this.dialog.open(AnalysisHtmlDialogComponent, {
          data: html,
          panelClass: 'prisca-fullscreen-dialog',
          autoFocus: false,
          restoreFocus: false,
          width: '96vw',
          height: '95vh',
          maxWidth: '96vw',
          maxHeight: '95vh',
        });
      },
      error: (err) => {
        this.httpMsgHandler.handleMsg(err);
      },
    });
  }

  openPriscaInteractive(): void {
    if (!this.validateBeforeAnalysis()) {
      return;
    }

    const { patologias, alergias, moleculas } = this.getdetailsAnalytics();
    const prescription = this.prescriptionForm.getRawValue();
    prescription.pregnancy = !!prescription.pregnancy;

    const allLines = this.prescriptionDataSource.getValue() ?? [];
    const analysableSrc = allLines.filter(l => String(l.drug ?? '').trim() !== '0');

    if (!this.patient?.idPaciente) {
      Swal.fire('AVISO', 'PRIMERO SELECCIONA UN PACIENTE.', 'info');
      return;
    }

    if (analysableSrc.length === 0) {
      Swal.fire('AVISO', 'AGREGA AL MENOS UN MEDICAMENTO PARA PRISCA INTERACTIVO.', 'info');
      return;
    }

    const prescriptionLines = analysableSrc.map(line => ({
      drugType: line.drugType,
      drug: line.drug,
      dose: line.dose,
      unitId: line.unitId ? line.unitId : 0,
      frecuency: line.frecuency,
      frecuencyType: line.frecuencyType,
      idFrecuencyType: line.idFrecuencyType,
      duration: line.duration,
      durationType: line.durationType,
      route: line.route ? line.route : 0,
      indication: String(Number(line.indication ?? 0))
    }));

    const payload = {
      patient: {
        idPaciente: this.patient.idPaciente,
        gender: prescription.gender,
        dateOfBirth: prescription.dateOfBirth,
        weight: Number(prescription.weight ?? 0),
        height: Number(prescription.height ?? 0),
        breastFeeding: prescription.breastFeeding,
        weeksOfAmenorrhea: prescription.weeksOfAmenorrhea,
        pregnancy: prescription.pregnancy,
        creatin: prescription.creatin || 120,
        molecules: moleculas,
        allergies: alergias,
        pathologies: patologias,
      },
      prescriptionLines,
      medicamentoActivo: this.medicamentoActivo ?? []
    };

    this.prescriptionService.postToPriscaInteractive(payload).subscribe({
      next: (resp: any) => {

        let html = resp?.data?.htmlResponse ?? resp?.data ?? '';

        if (typeof html === 'string' && html.includes(':')) {
          try {
            html = decryptData(html, environment.encryptionKey);
          } catch (e) {
          }
        }

        if (!html || typeof html !== 'string') {
          Swal.fire('AVISO', 'NO SE RECIBIO HTML DE PRISCA INTERACTIVO.', 'info');
          return;
        }

        // 🔹 Abrir nueva pestaña
        const newTab = openBlankWindow();

        if (!newTab) {
          Swal.fire('ERROR', 'EL NAVEGADOR BLOQUEÓ LA NUEVA PESTAÑA.', 'error');
          return;
        }

        newTab.document.open();
        newTab.document.write(html);
        newTab.document.close();
      },

      error: (err) => {
        console.error(err);
        this.httpMsgHandler.handleMsg(err);
      }
    });
  }

}
